import { Field, ErrorMessage, useFormikContext } from "formik"
import { ReactNode } from "react";

interface CheckboxInterface {
    name: string,
    text?: string,
    children?: ReactNode,
    error?: boolean
}

const Checkbox = ({ name, text, children, error }: CheckboxInterface) => {
    return (
        <>
            <label className="configurator-checkbox d--flex gap-8">
                <span className="custom-control">
                    <Field
                        autoFocus={error}
                        className={"visually-hidden"}
                        name={name} id={name}
                        type="checkbox" />
                    <span className={`custom-control__element ${error ? 'error' : ''}`}></span>
                </span>
                <span className="d--flex color--blue-dark">
                    {text || children}
                </span>
            </label>
            <ErrorMessage name={name} component={"div"} className={"configurator-content__error rte links-underline"} />
        </>
    );
}

export default Checkbox;